export const formFieldStyles = {
  field: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'primary.main',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderWidth: '2px',
      },
    },
    '& .MuiInputLabel-root': {
      fontWeight: 500,
      '&.Mui-focused': {
        color: 'primary.main',
      },
    },
  },

  switchField: {
    display: 'flex',
    alignItems: 'center',
    height: '56px',
    '& .MuiFormControlLabel-label': {
      fontWeight: 500,
    },
  },

  checkboxField: {
    display: 'flex',
    alignItems: 'center',
    height: '56px',
    '& .MuiFormControlLabel-label': {
      fontWeight: 500,
    },
  },
};
